// breather/scene/SceneGraph.ts
import { Engine } from '../core/Engine'
import { Scene, PerspectiveCamera, Color } from 'three'

export class SceneGraph {
  engine: Engine
  scene: Scene
  camera: PerspectiveCamera

  constructor(engine: Engine){
    this.engine = engine
    const { clientWidth:w, clientHeight:h } = engine.el

    this.scene = new Scene()
    this.scene.background = new Color(0x000000)

    this.camera = new PerspectiveCamera(35, w / h, 0.1, 100)
    this.camera.position.set(0, 0, 4.2)

    // keep aspect on resize
    const onResize = () => {
      const { clientWidth: w2, clientHeight: h2 } = this.engine.el
      this.camera.aspect = w2 / h2
      this.camera.updateProjectionMatrix()
    }
    window.addEventListener('resize', onResize)
    onResize()
  }

  render(composer?: any){
    if (composer) composer.render()
    else this.engine.renderer.render(this.scene, this.camera)
  }
}
